import React from 'react';
import '../../App.css';
import {Col, Row} from "react-bootstrap";

function HeaderPart(props) {

    return (
        <Row>
            <Col lg={7} style={{"whiteSpace": "nowrap"}}>
                <span style={props.warning ? {color:"red"} : {color: "black"}}>{props.information.split("-")[1]}</span>
            </Col>
        </Row>
    );
}

export default HeaderPart;
